<template>
    <app-page-options-list :options="options" />
</template>
<script>
    import PageOptionsList from '../../UI/Controls/PageOptions/PageOptionsList.vue';
    export default {
        components: {
            appPageOptionsList: PageOptionsList
        },
        data(){
            return {
                options: [
                    { to: 'listStructures', label: 'Estructuras' },
                    { to: 'assignations', label: 'Asignaciones' },
                    { to: 'listUsers', label: 'Usuarios' },
                    { to: 'clientsPage', label: 'Clientes' },
                    { to: 'peoplePageList', label: 'Personas' },
                    { to: 'vehiclesPage', label: 'Vehiculos'},
                    { to: 'vigilantAccess', label: 'Acceso vigilantes'},
                    { to: 'dutiesPage', label: 'Consignas'},
                    { to: 'positionsPage', label: 'Cargos'},
                    { to: 'itemTypesPage', label: 'Tipos de herramientas'},
                    { to: 'itemPage', label: 'Herramientas'}
                ]
            }
        }
    }
</script>